import api from 'axios'
import {clearFlash} from "../components/FlashMessage";

/**
 * Signal types
 */
export const LOAD_ALL = 'abl-backoffice/application/LOAD_ALL'
export const RESET_ALL = 'abl-backoffice/application/RESET_ALL'
export const RESET_ONE = 'abl-backoffice/application/RESET_ONE'
export const LOAD_APPLICATION = 'abl-backoffice/application/LOAD_APPLICATION'

/**
 * Action to load an application.
 *
 * @param application
 * @returns {{type, application: *}}
 */
export const loadOne = application => {
	return {type: LOAD_APPLICATION, application}
}

/**
 * Action to initialize an application.
 *
 * @returns {{type, application: *}}
 */
export const initializeOne = () => {

	const application = AblCh.applicationIdentifier
		? AblCh.application // global object
		: {
			mainApplicant: AblCh.webMember,
			applicationItems: []
		}

	return loadOne(application)
}

/**
 * @param {object} values
 * @param {string} callForApplication
 * @returns {Promise.<T>}
 */
export const create = function(values, callForApplication = null) {

	const requestUri = callForApplication ? '/webapi/application/' + callForApplication : '/webapi/application';

	const request = api.post(requestUri, {
		application: values,
		__csrfToken: AblCh.csrfToken
	})

	return dispatch => {

		return request
			.then(response => {

        // todo: in case of an exception on creation the api returns a 'false' false or 'true' string! which seems not to be seen by catch, which returns a false confirmation here
        if (response.data === false) {
          return Promise.reject(response.data)
        }

				// hack to set back form to pristine
				// response.data.touched = "";

				// Refresh form with data coming from the server.
				// dispatch(loadOne(response.data))
				// dispatch(resetAll)
				return response.data;
			})
			.catch(response => {
				return Promise.reject(response.data)
			})
	}
}

/**
 * @param {object} values
 * @returns {Promise.<T>}
 */
export const update = function(values) {

	const request = api.put('/webapi/application', {
		application: values,
		__csrfToken: AblCh.csrfToken
	})

	return dispatch => {
		return request
			.then(response => {
				return response.data;
			})
			.catch(response => {
        // todo: check and improve error handling if appropriate
				return Promise.reject(response.data)
			})
	}
}
